// extracted by mini-css-extract-plugin
export var imageContainer = "styles-module__imageContainer___ywidH";
export var changeImage = "styles-module__changeImage___fOY8_";